import { loadAllFilms } from './load-all-films';
import { loadFilmsForSite } from './load-films-for-site';
export const loadFilms = async (siteId) => {
    if (siteId)
        return loadFilmsForSite(siteId);
    else
        return loadAllFilms();
};
